import { useMutation } from '@tanstack/react-query';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useNotification } from '../../notification/notificationsContext';
import { TenantNotificationSettingsDto } from '../dto';

export const useUpdateTenantNotificationSettingsMutation = (source: string) => {
  const { billingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const { notifySuccess, notifyError } = useNotification();

  return useMutation(
    async (tenantNotificationSettings: TenantNotificationSettingsDto) =>
      billingApi.updateTenantNotificationSettings(tenantNotificationSettings),
    {
      onMutate: async (tenantNotificationSettings: TenantNotificationSettingsDto) => {
        await queryCacheManager.updateTenantNotificationSettings(tenantNotificationSettings);
      },
      onSuccess: async (tenantNotificationSettings: TenantNotificationSettingsDto) => {
        await queryCacheManager.invalidateBillingCustomer();
        analyticsTrack(
          tenantNotificationSettings.smsEnabled
            ? AnalyticsEvent.TENANT_SMS_NOTIFICATIONS_ENABLED
            : AnalyticsEvent.TENANT_SMS_NOTIFICATIONS_DISABLED,
          { source }
        );
        const message = `Notification settings updated.`;
        notifySuccess({ logMsg: message, notificationMsg: message });
      },
      onError: async () => {
        await queryCacheManager.invalidateBillingCustomer();
        const message = `Something went wrong while updating notification settings.`;
        notifyError({ logMsg: message, notificationMsg: message });
      },
    }
  );
};
